// eslint-disable-next-line max-classes-per-file
function animateItemsInViewport() {
  const parentElements = document.querySelectorAll('.animate-parent-in-viewport');

  parentElements.forEach((parentElement) => {
    const items = parentElement.querySelectorAll('.animate-item-in-viewport');

    if (items.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('animate-item');
              observer.unobserve(entry.target);
            }, index * 150);
          }
        });
      },
      { threshold: 0.25 }
    );

    items.forEach((item) => observer.observe(item));
  });
}

class FacetMoreLess extends HTMLElement {
  constructor() {
    super();

    this.clickCount = 0;
    this.filterItems = JSON.parse(this.querySelector('[data-filter-items]').innerHTML);
    this.itemsToFilter = null;

    if (!Object.values(this.filterItems)?.length === 0 || this.filterItems?.filter_values?.length <= 5) {
      this.querySelector('[data-id="more"]').style.display = 'none';

      return;
    }

    this.addEventListener('click', function (e) {
      if (e.target.dataset.id === 'more') {
        this.clickCount += 1;
      } else if (e.target.dataset.id === 'less') {
        this.clickCount -= 1;
      }

      if (this.filterItems?.filter_label === 'Color') {
        this.itemsToFilter = this.filterItems.filter_values.map(
          (item, index) => `
          <div class="py-3" data-filter-element>
            <label for="Filter-${item.param_name}--${index + 1}" class="flex items-center">
              <input
                type="checkbox"
                id="Filter-${item.param_name}--${index + 1}"
                class="
                ${
                  theme.collection.enableColorSwatches
                    ? `peer
                  absolute
                  left-0
                  top-0
                  -z-1
                  h-full
                  w-full
                  opacity-0`
                    : `peer
                    form-checkbox
                    mr-2
                    h-6
                    w-6
                    shrink-0
                    border-base-border
                    bg-base-body-background
                    text-base-body
                    rounded-form-element
                    checked:bg-[length:75%_75%]
                    focus:ring-0
                    focus:ring-opacity-0
                    focus:ring-offset-0
                    focus:ring-offset-transparent
                    disabled:bg-base-accent`
                }
                "
                name="${item.param_name}"
                  value="${item.label}"
                ${item.active && 'checked'}
                ${item.count === 0 && item.active === false && 'disabled'}
                >
                ${
                  theme.collection.enableColorSwatches
                    ? `
                <span class="
                  group
                  relative
                  mr-2
                  h-6
                  w-6
                  shrink-0
                  cursor-pointer
                  overflow-hidden
                  rounded-full
                  border
                  border-base-border
                  p-[1px]
                  transition-colors
                  duration-300
                  after:absolute
                  after:left-1/2
                  after:top-1/2
                  after:z-2
                  after:h-full
                  after:w-[1px]
                  after:-translate-x-1/2
                  after:-translate-y-1/2
                  after:rotate-45
                  after:bg-base-overlay-white
                  after:opacity-0
                  after:content-['']
                  peer-checked:border-base-body
                  peer-focus:border-base-body
                  peer-disabled:cursor-default
                  peer-disabled:after:opacity-100
                ">
                  <span
                    style="background-color: ${item.value};"
                    class="block h-full w-full group-[&.rounded-full]:rounded-full"
                  ></span>
                </span>
              `
                    : ''
                }
              <span class="peer-disabled:text-base-secondary">

                ${item.label} (${item.count})
              </span>
            </label>
          </div>
        `
        );
      } else {
        this.itemsToFilter = this.filterItems.filter_values.map(
          (item, index) =>
            `
          <div class="py-3 flex items-center" data-filter-element>
            <input
              type="checkbox"
              id="Filter-${item.param_name}-${index + 1}"
              class="
                peer
                form-checkbox
                relative
                mr-2
                h-6
                w-6
                shrink-0
                overflow-hidden
                rounded-form-element
                border-base-border
                bg-base-body-background
                text-base-body
                after:absolute
                after:left-1/2
                after:top-1/2
                after:h-[150%]
                after:w-[1px]
                after:-translate-x-1/2
                after:-translate-y-1/2
                after:rotate-45
                after:bg-base-border
                after:opacity-0
                after:content-['']
                checked:bg-[length:75%_75%]
                focus:ring-0
                focus:ring-opacity-0
                focus:ring-offset-0
                focus:ring-offset-transparent
                disabled:cursor-default
                disabled:after:opacity-100
            "
              value="${item.value}"
              name="${item.param_name}"
              ${item.active && 'checked'}
              ${item.count === 0 && item.active === false && 'disabled'}
            >
            <label for="Filter-${item.param_name}-${index + 1}" class="w-full peer-disabled:text-base-secondary">
              ${item.label} (${item.count})
            </label>
          </div>
          `
        );
      }

      this.queryVar = this.filterItems?.filter_label === 'Color' ? 'colors' : 'square';

      const filterSlideContainer = this.parentElement.querySelector('[data-filter-slide-container]');

      this.insertAfterEl = filterSlideContainer || this.parentElement;

      if (this.clickCount >= 1) {
        this.querySelector('[data-id="less"]').style.display = 'inline';
      }

      if (e.target.dataset.id === 'less') {
        if (this.clickCount * 5 + 5 < this.itemsToFilter.length) {
          this.querySelector('[data-id="more"]').style.display = 'inline';
        }

        this.items = this.parentElement.querySelectorAll(`[data-filter-element]`);

        this.items.forEach((el, index) => {
          if (index + 1 > this.clickCount * 5 + 5) {
            el.remove();
          }
        });

        if (this.clickCount === 0) {
          this.querySelector('[data-id="less"]').style.display = 'none';
        }
      } else if (e.target.dataset.id === 'more') {
        if (this.clickCount * 5 + 5 >= this.itemsToFilter.length) {
          this.querySelector('[data-id="more"]').style.display = 'none';
        }

        this.insertAfterEl.insertAdjacentHTML(
          'beforeend',
          this.itemsToFilter.slice(this.clickCount * 5, this.clickCount * 5 + 5).join('')
        );
      }
    });
  }

  insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }
}

customElements.define('more-less', FacetMoreLess);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const filterSelectors = document.querySelectorAll('#filter-sortby, #filter-sortby-2');

    const self = this;

    filterSelectors.forEach(
      (filterSelector) =>
        filterSelector.addEventListener('change', function (e) {
          const id = this.getAttribute('id');
          let surplusFilter;

          if (id === 'filter-sortby') {
            surplusFilter = document.getElementById('filter-sortby-2');
          } else {
            surplusFilter = document.getElementById('filter-sortby');
          }

          const tempValue = surplusFilter.value;

          if (surplusFilter) surplusFilter.value = '';

          const dbSubmit = self.debouncedOnSubmit.bind(self, e);

          dbSubmit().then(() => (surplusFilter.value = tempValue));
        }),
      self
    );

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');

    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Set up mutation observer for filter-selected-element-list visibility
    const selectedElementList = document.querySelector('.filter-selected-element-list');

    if (selectedElementList) {
      const handleChanges = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const activeFiltersElement = selectedElementList.querySelector('[data-active-filters]');

            if (activeFiltersElement && selectedElementList.classList.contains('hidden')) {
              selectedElementList.classList.remove('hidden');
              selectedElementList.classList.add('flex');
            } else if (!activeFiltersElement && selectedElementList.classList.contains('flex')) {
              selectedElementList.classList.add('hidden');
              selectedElementList.classList.remove('flex');
            }
          }
        }
      };

      const observer = new MutationObserver(handleChanges);

      observer.observe(selectedElementList, {
        childList: true,
        subtree: true,
      });

      // Check initial state on page load
      const initialActiveFiltersElement = selectedElementList.querySelector('[data-active-filters]');
      
      if (initialActiveFiltersElement && selectedElementList.classList.contains('hidden')) {
        selectedElementList.classList.remove('hidden');
        selectedElementList.classList.add('flex');
      } else if (!initialActiveFiltersElement && selectedElementList.classList.contains('flex')) {
        selectedElementList.classList.add('hidden');
        selectedElementList.classList.remove('flex');
      }
    }

    FacetFiltersForm.checkActiveFilters();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderPagination(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.triggerUpdateQuickViewEvent();
      })
      .then(() => {
        animateItemsInViewport();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const { html } = FacetFiltersForm.filterData.find(filterDataUrl);

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderPagination(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.triggerUpdateQuickViewEvent();
    animateItemsInViewport();
  }

  static renderProductGridContainer(html) {
    document.getElementById('product-grid').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('product-grid').innerHTML;

    const rerenderedPageEvent = new Event('collectionPageRerender');

    document.dispatchEvent(rerenderedPageEvent);
  }

  static renderPagination(html) {
    const paginationWrapper = document.getElementById('pagination-container');

    if (paginationWrapper) {
      paginationWrapper.innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('pagination-container').innerHTML;
    }

    document.dispatchEvent(new CustomEvent('filterChange'));
  }

  static renderProductCount(html) {
    const updatedContainer = new DOMParser().parseFromString(html, 'text/html');
    const count = updatedContainer.getElementById('ProductCountDesktop').innerHTML;

    const totalProductsCount = updatedContainer.querySelector('[data-total-products-quantity]').dataset
      .totalProductsQuantity;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const productsContainer = document.querySelector('[data-total-products-quantity]');

    if (container) container.innerHTML = count;

    if (containerDesktop) containerDesktop.innerHTML = count;

    productsContainer?.setAttribute('data-total-products-quantity', totalProductsCount);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter',
      '#FacetFiltersMobile .js-filter'
    );

    // Store current open state before updating
    const currentOpenStates = new Map();
    const currentFilters = document.querySelectorAll('#FacetsWrapperDesktop .js-filter, #FacetFiltersMobile .js-filter');
    currentFilters.forEach((filter) => {
      const index = filter.dataset.index;
      const container = filter.closest('#FacetsWrapperDesktop') ? 'desktop' : 'mobile';
      currentOpenStates.set(`${container}-${index}`, filter.hasAttribute('open'));
    });

    if (window.innerWidth >= 1024) {
      facetDetailsElements.forEach((element) => {
        element.setAttribute('open', 'open');
      });
    }

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;

      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const filterSlideContainer = element.querySelector('[data-filter-slide-container]');
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML, currentOpenStates);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html, currentOpenStates = new Map()) {
    const activeFacetElementSelectors = ['.filter-selected-element-list'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;

      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    // Refresh <input /> values in container of filter adjustments.
    document.querySelector('#FacetsWrapperDesktop').innerHTML = html.querySelector('#FacetsWrapperDesktop').innerHTML;
    
    // Also update mobile filters container if it exists
    const mobileContainer = document.querySelector('#FacetFiltersMobile');
    const newMobileContainer = html.querySelector('#FacetFiltersMobile');
    if (mobileContainer && newMobileContainer) {
      mobileContainer.innerHTML = newMobileContainer.innerHTML;
    }

    // Restore open state for filters with active values or previously open filters
    const updatedFilters = document.querySelectorAll('#FacetsWrapperDesktop .js-filter, #FacetFiltersMobile .js-filter');
    updatedFilters.forEach((filter) => {
      const index = filter.dataset.index;
      const container = filter.closest('#FacetsWrapperDesktop') ? 'desktop' : 'mobile';
      
      // Check for active values in different input types
      const checkedInputs = filter.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length > 0;
      const numberInputsWithValues = Array.from(filter.querySelectorAll('input[type="number"]')).some(input => input.value.trim().length > 0);
      const hasActiveValues = checkedInputs || numberInputsWithValues;
      
      const wasOpen = currentOpenStates.get(`${container}-${index}`);
      
      // Keep filter open if it has active values or was previously open
      if (hasActiveValues || wasOpen) {
        filter.setAttribute('open', 'open');
      } else if (wasOpen === false) {
        // Only close if it was explicitly closed before
        filter.removeAttribute('open');
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.checkActiveFilters();
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;

      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGridSectionId = document.getElementById('product-grid')?.dataset?.id
    
    if(!productGridSectionId) {
      return []
    }

    return [
      {
        section: productGridSectionId,
      },
    ];
  }

  static checkActiveFilters() {
    const clearAllBtn = document.querySelector('facet-remove[data-facet-clear-all]');

    const activeFilter = Array.from(document.querySelectorAll('#FacetsWrapperDesktop input')).find((input) => {
      if (input.type === 'number') {
        return input.value.trim().length;
      }

      return input.checked;
    });

    if (activeFilter) {
      FacetFiltersForm.renderClearAll(clearAllBtn);
    } else {
      FacetFiltersForm.hideClearAll(clearAllBtn);
    }
  }

  static renderClearAll(clearAll) {
    clearAll.removeAttribute('hidden');
  }

  static hideClearAll(clearAll) {
    clearAll.setAttribute('hidden', true);
  }

  static triggerUpdateQuickViewEvent() {
    const updateQuickViewEvent = new CustomEvent('updateQuickView');

    document.dispatchEvent(updateQuickViewEvent);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    let formData;
    let searchParams;

    if (event?.target?.closest('form')) {
      formData = new FormData(event.target.closest('form'));
      searchParams = new URLSearchParams(formData).toString();
    } else {
      const form = document.getElementById('FacetFiltersForm');

      formData = new FormData(form);
      searchParams = new URLSearchParams(formData).toString();
    }

    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    
    // Get elements
    this.minRangeInput = this.querySelector('[data-min-range]');
    this.maxRangeInput = this.querySelector('[data-max-range]');
    
    // Get hidden inputs more specifically using the class and order
    const hiddenInputs = this.querySelectorAll('input[type="hidden"].range-slider__input');
    this.minHiddenInput = hiddenInputs[0] || null;
    this.maxHiddenInput = hiddenInputs[1] || null;
    
    this.minPriceDisplay = this.querySelector('[data-min-price-display]');
    this.maxPriceDisplay = this.querySelector('[data-max-price-display]');
    this.sliderContainer = this.querySelector('.dual-range-slider');
    
    if (!this.minRangeInput || !this.maxRangeInput) {
      return;
    }
    
    // Set up event listeners for real-time updates
    this.minRangeInput.addEventListener('input', this.onMinRangeChange.bind(this));
    this.maxRangeInput.addEventListener('input', this.onMaxRangeChange.bind(this));
    
    // Initialize the slider
    this.updateSliderProgress();
  }

  onMinRangeChange(event) {
    const minValue = parseInt(event.target.value);
    const maxValue = parseInt(this.maxRangeInput.value);
    
    // Ensure min doesn't exceed max
    if (minValue >= maxValue) {
      event.target.value = maxValue - 1;
    }
    
    this.updateValues();
    this.updateSliderProgress();
  }

  onMaxRangeChange(event) {
    const minValue = parseInt(this.minRangeInput.value);
    const maxValue = parseInt(event.target.value);
    
    // Ensure max doesn't go below min
    if (maxValue <= minValue) {
      event.target.value = minValue + 1;
    }
    
    this.updateValues();
    this.updateSliderProgress();
  }

  updateValues() {
    const minValue = this.minRangeInput.value;
    const maxValue = this.maxRangeInput.value;
    
    // Update hidden inputs (these are what get submitted with the form)
    if (this.minHiddenInput) {
      this.minHiddenInput.value = minValue;
    }
    
    if (this.maxHiddenInput) {
      this.maxHiddenInput.value = maxValue;
    }
    
    // Update price displays in real-time
    if (this.minPriceDisplay) {
      this.minPriceDisplay.textContent = this.formatPrice(minValue);
    }
    
    if (this.maxPriceDisplay) {
      this.maxPriceDisplay.textContent = this.formatPrice(maxValue);
    }
  }

  updateSliderProgress() {
    const min = parseInt(this.minRangeInput.min);
    const max = parseInt(this.minRangeInput.max);
    const minValue = parseInt(this.minRangeInput.value);
    const maxValue = parseInt(this.maxRangeInput.value);
    
    const minPercent = ((minValue - min) / (max - min)) * 100;
    const maxPercent = ((maxValue - min) / (max - min)) * 100;
    
    // Update the progress bar visual using CSS custom properties
    if (this.sliderContainer) {
      this.sliderContainer.style.setProperty('--min-percent', minPercent + '%');
      this.sliderContainer.style.setProperty('--max-percent', maxPercent + '%');
    }
  }

  formatPrice(value) {
    // Remove unnecessary zeros and format as integer
    return parseInt(value).toString();
  }

  // Legacy methods to maintain compatibility
  setMinAndMaxValues() {
    this.updateValues();
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const id = this.querySelector('a').getAttribute('id');

      if (id === 'price-range' || id === 'clear-all') {
        const priceRanges = document.querySelectorAll('.range-slider__input');

        priceRanges.forEach((rangeItem) => (rangeItem.value = ''));
      }

      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');

  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');

  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;

  return (...args) => {
    clearTimeout(t);

    return new Promise((resolve) => {
      t = setTimeout(() => resolve(fn(...args)), wait);
    });
  };
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
